import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';

import { CalendarModule, ConfirmDialogModule, DataScrollerModule, DataTableModule,
            DropdownModule, MenubarModule, TabViewModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { PersonHeaderService } from './person-header.service';
import { PersonHeaderComponent } from './person-header.component';
import { UpdatePersonComponent } from './updateperson/update-person.component';

import { TaskModule } from './../../task/task.module';

@NgModule({
    declarations: [
        PersonHeaderComponent,
        UpdatePersonComponent
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        DataScrollerModule,
        DropdownModule,
        TaskModule
    ],
    providers: [
        PersonHeaderService
    ],
    entryComponents: [
        UpdatePersonComponent
    ],
    exports: [
        PersonHeaderComponent
    ]
})

/**
 * Main module for the person header management.
*/
export class PersonHeaderModule { }



// WEBPACK FOOTER //
// ./src/app/person/header/person-header.module.ts